module.exports = __webpack_public_path__ + "static/media/RMC-capabilities.364c1ea7.jpg";